import React from 'react';

const EditIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.8307 17.4997H17.4973M17.6423 5.67633C18.0829 5.23585 18.3305 4.63839 18.3306 4.01538C18.3307 3.39237 18.0832 2.79484 17.6428 2.35425C17.2023 1.91366 16.6048 1.66609 15.9818 1.66602C15.3588 1.66594 14.7613 1.91335 14.3207 2.35383L3.19901 13.478C3.00552 13.6709 2.86244 13.9084 2.78234 14.1697L1.68151 17.7963C1.65997 17.8684 1.65834 17.945 1.6768 18.0179C1.69526 18.0908 1.73311 18.1574 1.78634 18.2105C1.83957 18.2636 1.90619 18.3014 1.97914 18.3197C2.05209 18.3381 2.12864 18.3363 2.20067 18.3147L5.82817 17.2147C6.08915 17.1353 6.32665 16.9931 6.51984 16.8005L17.6423 5.67633Z'
        stroke='#6E7079'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default EditIcon;
